import React from "react";
import {Redirect, Route} from "react-router-dom";
import Cookies from "js-cookie";

function PrivateScannerRoute({component: Component, render, ...rest}) {
    return (
        <Route
            {...rest}
            render={({location}, props) =>
                Cookies.get("scanner_id") !== undefined && Cookies.get("as") === "scanner" ? (
                    Component ? (
                        <Component {...props} />
                    ) : (
                        render()
                    )
                ) : (
                    <Redirect
                        to={{
                            pathname: "/scanner/auth",
                            state: {from: location},
                        }}
                    />
                )
            }
        />
    );
}

export default PrivateScannerRoute;
